import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import {
  activeSubUserAction,
} from "../../../store/reducers/subUserSlice";
import Notification from "../../../components/common/notification/Notification";

interface ActivationUserPopupProps {
  title?: string;
  open?: boolean;
  selectUser?: any;
  onHide?: () => void;
  clientDetails?: any;
  setFormData?: any;
  formData?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
}
interface UserDetail {
  status: string | null;
}
const ActivationUser: React.FC<ActivationUserPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset,
  selectUser,
  title,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const initialUserDetail = {
    status: "ACTIVE",
  };
  const [userDetail, setUserDetail] = useState<UserDetail>(initialUserDetail);
  const submitHandler = () => {
    // Construct the payload
    const payload = {
      status: "ACTIVE", // Include the status
      staff_id: selectUser?.staff_id, // Get the staff_id from selectUser
    };

    // Dispatch the action with the payload
    dispatch(activeSubUserAction(payload));
  };
  const closeModel = () => {
    setAlertModelShow(false);
  };
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={alertModalShow}
      title={"Activation"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Notification />
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure you want to active this user ?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ActivationUser;
